<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    Edit Airport Website URL
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <mat-form-field id="websiteField">
        <input matInput
               placeholder="Website URL"
               formControlName="website"
               [(ngModel)]="selectedWebsite">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
